import { AssetClassDistribution } from "types/AssetClassDistribution";
import { ActionType, getType } from "typesafe-actions";
import * as assetClassDistributionActions from "./assetClassDistributionActions";

export type AssetClassDistributionState = {
  [K in assetClassDistributionActions.AssetClassDistributionContentType]?: {
    loading?: boolean;
    data?: AssetClassDistribution[];
    error?: string;
  };
};

export type AssetClassDistributionActions = ActionType<typeof assetClassDistributionActions>;

export default function assetClassDistribution(
  state: AssetClassDistributionState = {},
  action: AssetClassDistributionActions
) {
  switch (action.type) {
    case getType(assetClassDistributionActions.load):
      return { ...state, [action.contentType]: { ...state[action.contentType], loading: true } };
    case getType(assetClassDistributionActions.loadSuccess):
      return {
        ...state,
        [action.contentType]: { loading: false, data: action.data, error: undefined },
      };
    case getType(assetClassDistributionActions.loadFail):
      return { ...state, [action.contentType]: { loading: false, error: action.error } };
    default:
      return state;
  }
}
